import { Link } from 'react-router-dom'
import { archiveSongs } from '../data/songs'
import { CoverArt } from '../components/CoverArt'

export function DemoArchivePage() {
  return (
    <div className="page">
      <header className="page-header">
        <p className="page-kicker">Catalog</p>
        <h1 className="page-title">Demo Archive</h1>
      </header>
      <div className="catalog">
        {archiveSongs.map((song) => (
          <Link key={song.slug} to={`/music/${song.slug}`} className="card">
            <div className="card-media">
              <CoverArt song={song} />
              <span className="card-watch">Watch</span>
            </div>
            <div className="card-body">
              <h2 className="card-title">{song.title}</h2>
              <p className="card-tag">{song.tagline}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
